import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { PatientEntity, SavePatient, Provider, FamilyPage, Family, FamilyPatient, SearchPatientEntity, ClearPageOfFamilies,  PatientStateModel, PatientContactInfo } from "huddyapi";
import { GetPageOfFamilies, EntitySearchResult, PatientTag } from "huddyapi";
import { DateUtil, Time } from 'huddyapi';
import { Observable, of, Subscription } from "rxjs";
import { catchError } from "rxjs/operators";
import { DesktopErrorHandler } from "../../services/errorHandler.service";


@Component({
  selector: 'edit-patient-dialog',
  templateUrl: 'edit-patient-dialog.component.html',
  styleUrls: ["./edit-patient-dialog.component.scss"]
})
export class EditPatientDialog  {
  
  panel : number = 0;
  sexes : string[] = [ 'FEMALE', 'MALE'];
  edited : PatientEntity;
  dob : string;
  providerSubscription: Subscription;
  providers: Provider[];
  @Select(state => state.compassState.providers) providers$: Observable<Provider[]>;
  @Select(state => state.familyState.currentPage) families$: Observable<FamilyPage>;
  @Select(state => state.patientState) patientState$: Observable<PatientStateModel>;
  patientStateSubscription : Subscription;
  familySubscription: Subscription;
  families : FamilyPatient[] = [];
  patientFamilies : FamilyPatient[] = [];
  patientAddresses : AddressInfo[] = [];
  addresses : AddressInfo[] = []
  phones : PhoneInfo[] = [];
  patientPhones : PhoneInfo[] = [];
  contactInfo : PatientContactInfo[];
  familyRelationships : string[] = ['Primary', 'Spouse', 'Child', 'Parent', 'Unrelated resident', 'Relation', 'Friend'];
  noPrimary : string[] = this.familyRelationships.slice(1);
  isNewFamily : boolean = true;
  launchedFromFamily : boolean = false;
  patientSaved : boolean = false;

  patientForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.minLength(5), Validators.email]],
    firstName:  ['', [Validators.required]],
    lastName:  ['', [Validators.required]],
    dob:  ['', [Validators.required]],
    provider:  ['', [Validators.required]],
    sex:  [''],
    postalCode:  [''],
    identifier:  [''],
    familyIdentifier : new UntypedFormControl('', Validators.maxLength(12)),
    address : new UntypedFormControl('', Validators.minLength(3)),
    phone : new UntypedFormControl('', Validators.minLength(3)),
    newPhone : new UntypedFormControl('', Validators.minLength(10)),
    newContactType : new UntypedFormControl('', Validators.minLength(3)),
    newContactId : new UntypedFormControl('', Validators.minLength(3)),
    street1:  [''],
    street2:  [''],
    city:  [''],
    state:  [''],
    familyRelationship : ['Primary'],
    tags : ['']

});

  constructor(
    public dialogRef: MatDialogRef<EditPatientDialog>,
    @Inject(MAT_DIALOG_DATA) public data: PatientDialogInput,
    private formBuilder : UntypedFormBuilder,
    public store : Store,
    public errorHandler: DesktopErrorHandler
  )
  {
    this.launchedFromFamily = data.fromFamily;
   
    if (this.launchedFromFamily) {
      data.patient.identifier = '';
    }

    this.patientForm.setValue({
      email:  data.patient.username ?? '',
      identifier:  data.patient.identifier ?? '', 
      firstName:  data.patient.firstName ?? '',
      lastName:  data.patient.lastName ?? '',
      dob: this.toDateOfBirthFromEpochDay( data.patient.dob),
      postalCode:  data.patient.postalCode ?? '',
      sex:  data.patient.sex  ?? '',
      provider:  data.patient.providerId ?? '',
      familyIdentifier :  '',
      address : '', 
      phone : '', 
      newPhone: '',
      newContactType: '',
      newContactId: '',
      street1 : '',
      street2 : '',
      city : '',
      state : '',
      familyRelationship: '' ,
      tags: ''
    });
    this.edited = {
      id :  data.patient.id,
      identifier:  data.patient.identifier ?? '', 
      firstName:  data.patient.firstName ?? '',
      lastName:  data.patient.lastName ?? '',
      username:  data.patient.username ?? '',
      dob:  data.patient.dob,
      postalCode:  data.patient.postalCode ?? '',
      providerId:  data.patient.providerId,
      sex:  data.patient.sex  ?? '',
      userId :  data.patient.userId ?? 0,
    };
    console.log('edited=', this.edited);
    if ( data.patient.addresses) {
      this.patientAddresses =  data.patient.addresses.map(address => {
        return {
         description: (address.street1 ?? '') + ' ' +
        (address.street2  ?? '') + ' ' +
        (address.city  ?? '') + ' ' +
        (address.state  ?? '') + ' ' +
        (address.postalCode ?? '') ,
        street1: address.street1,
        street2: address.street2,
        city: address.city,
        state: address.state,
        postalCode: address.postalCode
        }  });
    }
    if ( data.patient.phones) {
      this.patientPhones =  data.patient.phones.map(phone => {
        return {
          description: '(' + phone.area + ') ' + phone.number.substring(0,3) + '-' + phone.number.substring(3)  ,
          area: phone.area,
          number : phone.number
        } })
    }
    this.contactInfo = [];
    if (data.patient.patientContactInfo) {
      this.contactInfo = this.contactInfo.concat(data.patient.patientContactInfo);
    }
    if ( data.patient.tags) {
      let tags : string =  data.patient.tags.filter(t => t.tagEntity === 'PATIENT').map(t => t.text).join(',');
      this.patientForm.controls.tags.setValue(tags);
    }
    if ( data.patient.familyRelationships) {
      this.patientFamilies =  data.patient.familyRelationships;
      console.log('family relationships', this.patientFamilies);
    }
  }

  ngOnInit(): void {
    this.providerSubscription = this.providers$.subscribe((providers: Provider[]) => {
      this.providers = providers;
      if (this.providers.length === 1) {
        this.patientForm.value.provider = this.providers[0].id;
      }
    });
    this.familySubscription = this.families$.subscribe((familyPage: FamilyPage) => {
     
        this.families = [];
        if (familyPage && familyPage.content) {
          console.log('SETTING FAMILY CONTENT');
          let families : Family[] = familyPage.content;
          this.families = families.map((f : Family) => ({
            familyId : f.id,
            familyIdentifier : f.identifier,
            description :  this.familyDescription('PRIMARY', f.identifier , f.namedPrimary, f.primaryAddress,),
            relationship: 'PRIMARY',
            patientId : this.edited.id,
            status: 'NOT_CONSENTED'
          }));
        }
        console.log( 'EditPatientDialog', 'families', this.families, familyPage);
       
    });
    this.patientStateSubscription = this.patientState$.subscribe((patientState: PatientStateModel) => {
      if (patientState.entitySearchResults && patientState.entitySearchResults.length > 0) {
        if (patientState.entitySearchResults[0].entity == 'address') {
          this.addresses = patientState.entitySearchResults.map(r => ({
            id : r.id,
            description: r.description
          }));

        } else {
          this.phones = patientState.entitySearchResults.map(r => ({
            id : r.id,
            description: r.description
          }));
        }
      }
      if (patientState.currentPatient && this.patientSaved) {
        this.patientSaved = false;
        this.close(patientState.currentPatient);
      }
      console.log( 'EditPatientDialog', 'search', this.phones, this.addresses);
  })
  }
  familyDescription(relationship : string, identifier: string, namedPrimary: string, primaryAddress: string): string {
    return [relationship, identifier, namedPrimary, primaryAddress].join(' ');
  }

  onNext() {
    if (this.panel + 1 === 1 && this.launchedFromFamily) {
      this.panel = 2;
    } else {
      this.panel++;
    }
  }

  onPrevious() {
    if (this.panel - 1 === 1 && this.launchedFromFamily) {
      this.panel = 0;
    } else {
      this.panel--;
    }
  }


  isFormValid() {
 
    if (this.providers.length === 1) {
      this.patientForm.value.provider = this.providers[0].id;
    }

    return (
      this.patientForm.controls.email.valid &&
      this.patientForm.value.provider &&
      this.patientForm.controls.firstName.valid &&
      this.patientForm.controls.lastName.valid &&
      this.patientForm.controls.dob.valid

    );
  }

  onSubmitForm(patientForm) {
   this.save();
  }

  close(patient? : PatientEntity) {
      this.dialogRef.close(patient);
  }



  save() {
    console.log('in save', this.patientForm.value.provider, this.patientFamilies);
    this.edited.providerId = this.patientForm.value.provider;
    this.edited.username = this.patientForm.value.email;
    this.edited.dob = this.getDateOfBirthFromForm(this.patientForm.value.dob);
    this.edited.firstName = this.patientForm.value.firstName;
    this.edited.lastName = this.patientForm.value.lastName;
    this.edited.identifier =  this.patientForm.value.identifier;
    this.edited.sex = this.patientForm.value.sex;
    this.edited.postalCode = this.patientForm.value.postalCode;
    this.edited.providerId = this.patientForm.value.provider;
    this.edited.addresses = this.patientAddresses.map(a => ({
      id : a.id  ?? null,
      street1 : a.street1,
      street2 : a.street2,
      city : a.city,
      state : a.state,
      postalCode : a.postalCode,
      country : a.country,
      locationInfoId : a.locationInfoId
    }));
    this.edited.phones = this.patientPhones.map(p => ({
      id : p.id ?? null,
      area : p.area,
      number :p.number,
      countryCode : p.countryCode
    }));
    this.edited.patientContactInfo = [].concat(this.contactInfo);
   
    this.edited.familyRelationships = this.patientFamilies.map(pf => {
      pf.relationship = pf.relationship.toUpperCase().replace(' ', '_');
      return pf;
    });
    let tags : PatientTag[] = (this.edited.tags) ? this.edited.tags.filter(t => t.tagEntity != 'PATIENT') : [];
    let editedTags : string = this.patientForm.value.tags;
    if (editedTags && editedTags.trim() != '') {

      tags = tags.concat(editedTags.trim().split(',').map(s => ({
        tagEntity : 'PATIENT',
        text : s,
        patientId : this.edited.id,
        entityId : this.edited.id
      })));
    }
    this.edited.tags = tags;
    console.log('SAVING PATIENT', this.edited, this.patientAddresses, this.patientFamilies, tags);

    this.store.dispatch(new SavePatient(this.edited))
    .pipe(
      catchError(err => {
        console.log('ERROR!!!!!', err.error);
        this.errorHandler.handle(err.error);
        return of ('');
      })
    )
    .subscribe(t => {
      console.log('Patient Saved!!!', t);
      this.patientSaved = true;
    });
    
  }
  getDateOfBirthFromForm(dob: string): number {
    let dt = new Time(dob);
    return dt.getEpochDay();
  }

  toDateOfBirthFromEpochDay(epochDay : number) {
    if (epochDay) {
      return DateUtil.fromEpochDay(epochDay).getYYYY_MM_DD();
    }
    return new Time().getYYYY_MM_DD();
  }

  getPageOfFamilies($event) {
    this.store.dispatch(new ClearPageOfFamilies());
    this.families = [];
    this.isNewFamily = true; 
    this.patientForm.controls.familyRelationship.setValue('Primary');
    let search : string = this.patientForm.value.familyIdentifier;
    if (search && search.length > 3) {
      const action : GetPageOfFamilies = new GetPageOfFamilies(0, 50, '', this.patientForm.value.familyIdentifier, '', 'asc');
      console.log('GetPageOfFamilies', 'dispatch', $event, action);
      this.store.dispatch(action);
    }
  }

  validFamilySelected() {
    let candidateIdentifier : string = this.patientForm.value.familyIdentifier;
    let candidateRelationship : string = this.patientForm.value.familyRelationship;
    if (candidateIdentifier && candidateIdentifier.length > 0 && 
      candidateRelationship && candidateRelationship.length > 0) {
      let candidate : FamilyPatient ={
        familyIdentifier : candidateIdentifier,
        familyId : null,
        description :  candidateRelationship.toUpperCase() + ' ' + candidateIdentifier,
        relationship: candidateRelationship,
        patientId : this.edited.id,
        status: 'NOT_CONSENTED'
      };
      let filtered = this.families.filter(f => f.familyIdentifier === candidate.familyIdentifier);
      if (filtered.length > 0) {
        let description : string = filtered[0].description;
        let idx : number = description.indexOf(' ');
        if (idx > -1) 
          description= candidateRelationship.toUpperCase() + ' ' + description.substring(idx);
        candidate = {
          familyIdentifier : filtered[0].familyIdentifier,
          familyId : filtered[0].familyId,
          description :  description,
          relationship: candidateRelationship,
          patientId : this.edited.id,
          status: 'NOT_CONSENTED'
        };
      }

      const found : FamilyPatient = this.patientFamilies.find(fp => fp.familyIdentifier === candidate.familyIdentifier);
      if (!found) {
        //console.log('valid family selected TRUE');
        return candidate;
      }
    }
    //console.log('valid family selected FALSE');
    return undefined;
  }

  addToFamily() {
    let candidate : FamilyPatient = this.validFamilySelected();
    if (candidate) {
      this.patientFamilies.push(candidate);
    } else {
      console.log('valid family not selected');
    }
  }

  familySelected() {
    console.log('FamilySelected setting isNewFamily false');
    this.isNewFamily = false;
  }

  getFamilyRelationships() {
    return (!this.isNewFamily) ? this.noPrimary : this.familyRelationships;
  }

  onRemovePatientFamily(familyIdentifier : string) {
    
    let idx : number = this.patientFamilies
    .findIndex((fp : FamilyPatient) => (fp.familyIdentifier === familyIdentifier));
    console.log('onRemovePatientFamily', familyIdentifier, this.patientFamilies, idx);
    if (idx > -1)
      this.patientFamilies.splice(idx, 1);
  }
  
  searchAddresses($event) {
     
    const action : SearchPatientEntity = new SearchPatientEntity('address', this.patientForm.value.address);
    console.log('searchAddresses', $event, action);
    this.store.dispatch(action)
  }

  searchPhones($event) {
     
    const action : SearchPatientEntity = new SearchPatientEntity('phone', this.patientForm.value.phone);
    console.log('searchPhones', $event, action);
    this.store.dispatch(action)
  }

  validAddressSelected(target? : AddressInfo) : AddressInfo {
    if (!target) {
      if (!this.patientForm.value.address)
      {
        return undefined;
      }
      let candidateAddress : string = this.patientForm.value.address;
      let filtered = this.addresses.filter(a => a.description.indexOf(candidateAddress) > -1);
      if (!filtered || filtered.length === 0) {
        return undefined;
      }
      target = filtered[0];
    } else {
      if (!target.street1 || !target.city || !target.postalCode || !target.description) {
        return undefined;
      }
    }
    if (this.patientAddresses && this.patientAddresses.length === 0) {
      return target;
    } 
    console.log('validAddressSelected', target, this.patientAddresses);
    let filtered = this.patientAddresses
      .filter((a : AddressInfo) => a.description === target.description);
    if (filtered.length === 0 ) {
      return target;
    }
    return undefined;
  }

  validPhoneSelected(target? : PhoneInfo) : PhoneInfo {
    //console.log('entering validPhoneSelected', target, this.patientForm.value.phone, this.phones);
    if (!target) {
      if (!this.patientForm.value.phone)
      {
        return undefined;
      }
      let candidatePhone : string = this.patientForm.value.phone;
      let filtered = this.phones.filter(a => a.description.indexOf(candidatePhone) > -1);
      if (!filtered || filtered.length === 0) {
        return undefined;
      }
      target = filtered[0];
      //console.log('Got target', target, candidatePhone, filtered);
    } else {
      if (!target.area || !target.number || !target.description) {
        return undefined;
      }
    }
    if (this.patientPhones && this.patientPhones.length === 0) {
      return target;
    } 
   // console.log('PHONEINFO', this.patientPhones, target);
   
    let filtered = this.patientPhones
      .filter((a : PhoneInfo) => a.description === target.description);
    if (filtered.length === 0 ) {
      return target;
    }
    return undefined;
  }

  addAddress() {
      let target : AddressInfo = this.validAddressSelected();
      if (target) {
        this.patientAddresses.push(target);
      }
  }

  addPhone() {
    let target : PhoneInfo = this.validPhoneSelected();
    if (target) {
      this.patientPhones.push(target);
    }
}

  toAddressInfo() {
    return {
      description: (this.patientForm.value.street1 ?? '') + ' ' +
      (this.patientForm.value.street2  ?? '') + ' ' +
      (this.patientForm.value.city  ?? '') + ' ' +
      (this.patientForm.value.state  ?? '') + ' ' +
      (this.patientForm.value.postalCode ?? '') ,
      street1: this.patientForm.value.street1,
      street2: this.patientForm.value.street2,
      city: this.patientForm.value.city,
      state: this.patientForm.value.state,
      postalCode: this.patientForm.value.postalCode
    };
  }

  toPhoneInfo() : PhoneInfo {
    let entered : string = this.patientForm.value.newPhone;
    if (entered) {
      entered = entered.replace(/\D/g, '');
      if (!entered || entered.length != 10) {
        return undefined;
      }
      const  area : string = entered.substring(0, 3);
      const  phNumber : string = entered.substring(3);
      return {
        description: '(' + area + ') ' + phNumber.substring(0,3) + '-' + phNumber.substring(3)  ,
        area: area,
        number : phNumber
      };
    }
  }

  createAddress() {
    let addressInfo : AddressInfo = this.toAddressInfo();
    addressInfo = this.validAddressSelected(addressInfo);
    if (addressInfo) {
      this.patientAddresses.push(addressInfo);
    }
  }

  createPhone() {
    let phoneInfo : PhoneInfo = this.toPhoneInfo();
    phoneInfo = this.validPhoneSelected(phoneInfo);
    if (phoneInfo) {
      this.patientPhones.push(phoneInfo);
    }
  }

  onRemoveAddress (description : string) {
    let idx : number = this.patientAddresses
    .findIndex((a : AddressInfo) => (a.description === description));
    console.log('onRemoveAddress', description, this.patientAddresses, idx);
    if (idx > -1)
      this.patientAddresses.splice(idx, 1);
  }

  onRemovePhone (description : string) {
    let idx : number = this.patientPhones
    .findIndex((a : PhoneInfo) => (a.description === description));
    console.log('onRemovePhone', description, this.patientPhones, idx);
    if (idx > -1)
      this.patientPhones.splice(idx, 1);
  }

  validContactInfoEntered() :boolean {
    return this.patientForm.controls.newContactType.valid && this.patientForm.controls.newContactId.valid;
  }

  addContactInfo() {
    const contactInfo = {
      contactType : this.patientForm.value.newContactType,
      contactIdentifier : this.patientForm.value.newContactId
    };
    this.contactInfo.push(contactInfo);
    this.patientForm.controls.newContactType.reset();
    this.patientForm.controls.newContactId.reset();
  }

  onRemoveContactInfo (idx : number) {
   
    console.log('onRemoveContactInfo',idx);
    if (idx > -1)
      this.contactInfo.splice(idx, 1);
  }

  us_states : USState[] = [ { name: 'Alabama', id: 'AL'}, { name: 'Alaska', id: 'AK'}, { name: 'American Samoa', id: 'AS'}, 
  { name: 'Arizona', id: 'AZ'}, { name: 'Arkansas', id: 'AR'}, { name: 'California', id: 'CA'}, { name: 'Colorado', id: 'CO'},
   { name: 'Connecticut', id: 'CT'}, { name:  'Delaware', id: 'DE'}, { name: 'District of Columbia', id: 'DC'},
    { name:  'Federated States of Micronesia', id: 'FM'}, { name: 'Florida', id: 'FL'}, { name: 'Georgia', id: 'GA'},
     { name: 'Guam', id: 'GU'}, { name:  'Hawaii', id: 'HI'}, { name: 'Idaho', id: 'ID'}, { name: 'Illinois', id: 'IL'}, 
     { name: 'Indiana', id: 'IN'}, { name: 'Iowa', id: 'IA'},{ name:  'Kansas', id: 'KS'}, { name: 'Kentucky', id: 'KY'},
     { name: 'Louisiana', id: 'LA'}, { name: 'Maine', id: 'ME'}, { name: 'Maryland', id: 'MD'}, 
     { name:  'Marshall Islands', id: 'MH'}, { name: 'Massachusetts', id: 'MA'}, { name: 'Michigan', id: 'MI'},
      { name: 'Minnesota', id: 'MN'},{ name:  'Mississippi', id: 'MS'}, { name: 'Missouri', id: 'MO'},
       { name: 'Montana', id: 'MT'}, { name: 'Nebraska', id: 'NE'}, { name: 'Nevada',  id : 'NV'}, { name: 'New Hampshire', id: 'NH'}, 
       { name: 'New Jersey', id: 'NJ'}, { name: 'New Mexico', id: 'NM'},{ name:  'New York', id: 'NY'}, 
       { name: 'North Carolina', id: 'NC'}, { name: 'North Dakota', id: 'ND'}, 
       { name:   'Northern Mariana Islands', id: 'MP'}, { name: 'Ohio', id: 'OH'}, { name: 'Oklahoma', id: 'OK'}, 
       { name: 'Oregon', id: 'OR'}, { name: 'Palau', id:  'PW'}, { name: 'Pennsylvania', id: 'PA'}, { name: 'Puerto Rico', id: 'PR'},
       { name: 'Rhode Island', id: 'RI'}, { name:  'South Carolina', id: 'SC'}, { name: 'South Dakota', id: 'SD'},
       { name: 'Tennessee', id: 'TN'}, { name: 'Texas', id: 'TX'}, { name:  'Utah', id: 'UT'}, { name: 'Vermont', id: 'VT'},
        { name: 'Virgin Islands', id: 'VI'}, { name: 'Virginia', id: 'VA'},{ name:  'Washington', id: 'WA'}, 
        { name: 'West Virginia', id: 'WV'}, { name: 'Wisconsin', id: 'WI'}, { name: 'Wyoming', id: 'WY'}];
}
export interface AddressInfo {
  id? : number;
  description : string;
  street1? : string;
  street2? : string;
  city? : string;
  postalCode? : string;
  state? : string;
  country? : string;
  locationInfoId? : number;
}

export interface PhoneInfo {
  id? : number;
  description : string;
  area? : string;
  number? : string;
  countryCode? : string;
}

export interface USState {
  name : string;
  id : string;
}

export interface PatientDialogInput {
  patient?: PatientEntity;
  fromFamily? : boolean;
}